"use strict";

var _defineProperty = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sqlLikeSyntaxToPagefindFilterSyntax = exports.splitKeyValue = exports.safeParseQueryToJson = exports.prepareString = exports.prepareOr = exports.prepareOperators = exports.prepareNeg = exports.arrValueNeg = exports.arrToSqlLikeSyntax = void 0;

var arrValueNeg = function arrValueNeg(value) {
  return typeof value === 'string' ? value.replace(/^-/, 'NOT ') : value;
};

exports.arrValueNeg = arrValueNeg;

var safeParseQueryToJson = function safeParseQueryToJson(data) {
  var parsedData;

  try {
    parsedData = typeof data === 'string' && (data === null || data === void 0 ? void 0 : data.length) !== 0 ? JSON.parse(data) : [];
  } catch (err) {
    console.log({
      data: data,
      err: err
    });
  }

  if (Array.isArray(parsedData)) {
    parsedData = parsedData.map(function (item) {
      return item.length === 1 ? item[0] : item;
    });
  }

  return parsedData;
};

exports.safeParseQueryToJson = safeParseQueryToJson;

var arrToSqlLikeSyntax = function arrToSqlLikeSyntax() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  if (params.length === 1 && typeof params[0] === 'string') {
    return arrValueNeg(params[0]);
  }

  return params.map(function (item) {
    if (Array.isArray(item)) {
      return "(".concat(item.map(arrValueNeg).join(' OR '), ")");
    }

    return arrValueNeg(item);
  }).join(' AND ');
};

exports.arrToSqlLikeSyntax = arrToSqlLikeSyntax;

var splitKeyValue = function splitKeyValue(field) {
  var arr = field.split(':');

  if (Array.isArray(arr) && arr.length > 1) {
    return _defineProperty({}, arr[0], arr[1]);
  }

  return field;
};

exports.splitKeyValue = splitKeyValue;

var prepareNeg = function prepareNeg(query) {
  if (typeof query === 'string' && query.startsWith('NOT')) {
    var value = splitKeyValue(query.replace(/^NOT\s/, ''));
    return {
      not: value
    };
  }

  return query;
};

exports.prepareNeg = prepareNeg;

var prepareOr = function prepareOr(query) {
  if (typeof query === 'string' && query.includes('(') && query.includes(')')) {
    var isNegated = query.startsWith('NOT');
    var any = query.replace('(', '').replace(')', '').split(/\sOR\s/).map(function (item) {
      return splitKeyValue(item.replace(/^NOT\s/, ''));
    });
    return isNegated ? {
      not: {
        any: any
      }
    } : {
      any: any
    };
  }

  return query;
};

exports.prepareOr = prepareOr;

var prepareString = function prepareString(query) {
  if (typeof query === 'string' && !query.startsWith('NOT')) {
    return splitKeyValue(query);
  }

  return query;
};

exports.prepareString = prepareString;

var prepareOperators = function prepareOperators(query) {
  return query.map(prepareOr).map(prepareString).map(prepareNeg);
};

exports.prepareOperators = prepareOperators;

var sqlLikeSyntaxToPagefindFilterSyntax = function sqlLikeSyntaxToPagefindFilterSyntax(query) {
  if (typeof query !== 'string') {
    return query;
  }

  return {
    all: prepareOperators(query.split(/\sAND\s/)).filter(Boolean)
  };
};

exports.sqlLikeSyntaxToPagefindFilterSyntax = sqlLikeSyntaxToPagefindFilterSyntax;